"use client";

import { createContext, use, type ReactNode } from "react";

const ListingActionResolvingContext = createContext(false);

export function ResolvingAction({
  isResolving,
  children,
}: {
  isResolving: boolean;
  children: ReactNode;
}) {
  return (
    <ListingActionResolvingContext value={isResolving}>
      <div className="contents" inert={isResolving} aria-busy={isResolving || undefined}>
        {children}
      </div>
    </ListingActionResolvingContext>
  );
}

export function useListingActionSettled(): boolean {
  return !use(ListingActionResolvingContext);
}
